import en from '../../profileContent.en';

const footer = {
    ...en.footer,
    phoneLabel: 'Tel.',
    emailLabel: 'Email'
  };

export default footer;
